import React from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { Code } from "rebass";
import { solarizedLight } from "react-syntax-highlighter/styles/hljs";
import CustomPre from "./CustomPre";

const SH = ({ code, language }) => {
  return (
    <SyntaxHighlighter
      showLineNumbers={true}
      language={language || "php"}
      style={solarizedLight}
      CodeTag={Code}
      PreTag={CustomPre}
    >
      {code}
    </SyntaxHighlighter>
  );
};

export default SH;



// WEBPACK FOOTER //
// ./src/components/SH.js